import Vue from 'vue'
import Router from 'vue-router'
import VueMeta from "vue-meta";
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
// import VueMeta from "vue-meta";
import VueScrollTo from 'vue-scrollto'
import Home from '@/components/Home'
import Books from '@/components/Books'
import AddTrip from '@/components/AddTrip'
import FindTrip from '@/components/FindTrip'
import Routes from '@/components/Routes'
import Styles from '@/components/Styles'
import Style from '@/components/Style'
import Country from '@/components/Country'
import States from '@/components/States'
import State from '@/components/State'
import Route from '@/components/Route'
import Continent from '@/components/Continent'
// import LinksList from '@/components/LinksList'
import Countries from '@/components/Countries'
import RidertagsAndSites from '@/components/RidertagsAndSites'
import FeatureACA from '@/components/FeatureACA'
import FeatureDesert from '@/components/FeatureDesert'
import FeatureCouple from '@/components/FeatureCouple'
import IndexFeature from '@/components/IndexFeature'
import IndexLevel1 from '@/components/IndexLevel1'
// import SitePages from '@/components/SitePages'
import HowItWorks from '@/components/HowItWorks'
import Contact from '@/components/Contact'
import AdminApproveNew from '@/components/AdminApproveNew'
import PageResultsList from '@/components/PageResultsList'
import AdminSitemap from '@/components/AdminSitemap'
import AdminTags from '@/components/AdminTags'
import AdminEmails from '@/components/AdminEmails'
import VueCookies from 'vue-cookies'

// import Affiliate from 'affiliate';
// const Affiliate = require('affiliate');
// const AffiliatePluginAmazon = require('affiliate-plugin-amazon');
// let amazonAff = AffiliatePluginAmazon(Affiliate, {
//   tags: {
//     us: 'bikesleepbike-20', // for USA, required
//     gb: '', // for UK
//     de: '', // for Germany
//     fr: '', // for France
//     jp: '', // for Japan
//     ca: 'bikesleepbike01-20', // for Canada
//     cn: '', // for China
//     it: '', // for Italy
//     es: '', // for Spain
//     in: '', // for India
//     br: '', // for Brazil
//     mx: '', // for Mexico
//   },
//   debug: true, // verbose logging into the console, default off
//   locale: null, // manually set the country code of the browser, default automatic
//   modifyDomain: true, // modify domains like amazon.com to amazon.co.uk based on locale, default on
// });

// // amazonAff is now an Affiliate instance

// amazonAff.attach(); // this will start affiliation

// import VueSocialSharing from 'vue-social-sharing'
// export const { isNavigationFailure, NavigationFailureType } = Router;

import TwitterButton from "vue-share-buttons/src/components/TwitterButton";
Vue.use(TwitterButton);

require('@/mystyles.scss');
Vue.use(VueCookies);
// Vue.use(VueSocialSharing);
Vue.use(Router);
Vue.use(VueMeta);
Vue.use(VueScrollTo);
Vue.use(Buefy, {
  defaultIconPack: 'fas'
});


Vue.$cookies.config('7d')


export default new Router({
  routes: [
    { //ADDED FOR REWRITES
      path: '/',
      name: 'IndexLevel1',
      component: IndexLevel1,
      props: true
      // props: {type: 'sites'}
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    }, 
    { //ADDED FOR REWRITES
      path: '/feature',
      name: 'IndexFeature',
      component: IndexFeature,
      // props: {type: 'sites'}
    },
    
    {
      path: '/share',
      name: 'AddTrip',
      component: AddTrip
    },
    
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    // {
    //   path: '/find',
    //   name: 'Home',
    //   component: Home
    // },
    {
      path: '/books',
      name: 'Books',
      component: Books
    },
    {
      path: '/books/:sub',
      name: 'BooksSub',
      component: Books,
      props: true
    },
    {
      path: '/about',
      name: 'HowItWorks',
      component: HowItWorks
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    
    {
      path: '/adminapprove',
      name: 'AdminApproveNew',
      component: AdminApproveNew
    },
    {
      path: '/admintags',
      name: 'AdminTags',
      component: AdminTags
    },
    {
      path: '/adminemails',
      name: 'AdminEmails',
      component: AdminEmails
    },
    {
      path: '/adminsitemap',
      name: 'AdminSitemap',
      component: AdminSitemap
    },
    {
      path: '/feature/adventurecycling',
      name: 'FeatureACA',
      component: FeatureACA,
      // props: {type: 'sites'}
    },
    {
      path: '/feature/desert',
      name: 'FeatureDesert',
      component: FeatureDesert,
      // props: {type: 'sites'}
    },
    {
      path: '/feature/couples',
      name: 'FeatureCouples',
      component: FeatureCouple,
      // props: {type: 'sites'}
    },
    
    {
      path: '/style/:style_name',
      name: 'Style',
      component: Style,
      props: true
      
    },
    {
      path: '/styles',
      name: 'Styles',
      component: Styles,
      
    },
    {
      path: '/countries/:country',
      name: 'Country',
      component: Country,
      props: true
    },
    // {
    //   path: '/countries/:country/:subregion',
    //   name: 'Subregion',
    //   component: Country,
    //   props: true
    // },
    // {
    //   path: '/regions/:region',
    //   name: 'Region',
    //   component: FindTrip
    // },
    {
      path: '/continents/:continent',
      name: 'Continent',
      component: Continent,
      props: true
      // props: {continent: continent}
      // alias: ['/continents/:continent']
    },
    {
      path: '/routes',
      name: 'Routes',
      component: Routes
    },
    {
      path: '/routes/:route',
      name: 'Route',
      component: Route,
      props: true
    },
    {
      path: '/ridertags/:ridertag',
      name: 'RiderTag',
      component: PageResultsList,
      props: true
    },
    {
      path: '/sites/:site',
      name: 'Site',
      component: PageResultsList,
      props: true
    },
    
    {
      path: '/countries',
      name: 'Countries',
      component: Countries,
      // props: {type: 'countries'}
    },
    // {
    //   path: '/us/states',
    //   name: 'States',
    //   component: States,
    //   // props: {type: 'countries'}
    // },
    {
      path: '/countries/United States/all',
      name: 'States',
      component: States,
      // props: true
    },
    {
      path: '/countries/United States/:state',
      name: 'State',
      component: State,
      props: true
    },
    {
      path: '/ridertags',
      name: 'RidertagsAndSites',
      component: RidertagsAndSites,
      props: {type: 'ridertags'}
    },
    // {
    //   path: '/continents',
    //   name: 'LinksList',
    //   component: LinksList,
    //   props: {type: 'continents'}
    // },
    {
      path: '/sites',
      name: 'RidertagsAndSites',
      component: RidertagsAndSites,
      props: {type: 'sites'}
    },
   

    {
      path: '/d/regions/:continent',
      redirect: '/:continent'
    },
    {
      path: '/d/country/:country',
      redirect: '/countries/:country'
    },
    {
      path: '/country/:country',
      redirect: '/countries/:country'
    },
    {
      path: 'd/route/:route',
      redirect: '/routes/:route'
    },
    {
      path: '/route/:route',
      redirect: '/routes/:route'
    },
    {
      path: '/route/:route',
      redirect: '/routes/:route'
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  mode:"history",
  linkActiveClass: 'is-active',
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash, behavior: 'smooth'};
    }
    if (to.path != from.path) {
      return { x: 0, y: 0 };
    }
    
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
//   scrollBehavior(to, from, savedPosition) {
//     if (to.path != from.path) {
//        return { x: 0, y: 0 };
//     }
//  }
})



// WEBPACK FOOTER //
// ./src/router/index.js